import { gql } from "@apollo/client";

export const getOrganizationMembers = gql`
  query GetOrganizationMembers($organizationId: String, $paginationArguments: PaginationArgumentsForwardInput) {
    GetOrganizationMembers(input: { organizationId: $organizationId, paginationArguments: $paginationArguments }) {
      connection {
        edges {
          cursor
          node {
            role {
              description
              groupId
              organizationId
              projectId
              roleId
              systemRole
              title
            }
            user {
              displayName
              email
              photoUrl
              userId
            }
          }
        }
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
        totalCount
      }
    }
  }
`;
